import { HelperFunction, Images } from '../Constants'
import { Link } from 'react-router-dom'
import { FaAngleRight, FaBars, FaCaretDown, FaRegClock, FaTimes } from "react-icons/fa";
import "../assets/css/header.css"
// import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { useEffect, useState } from 'react';

const Header = (props) => {
    // const [active1, setActive1] = useState(false);
    // const [active2, setActive2] = useState(false);
    // const [active3, setActive3] = useState(false);
    // const [finish2, setFinish2] = useState(false)
    // const step = props.indicator;
    // console.log('step',step)
    // useEffect(() => {
    //     switch(step) {
    //         case 1:
    //             setActive1(true);
    //             setActive2(false);
    //             setActive3(false);
    //             setFinish2(false)
    //             break;
    //         case 2:
    //             setActive1(false);
    //             setActive2(true);
    //             setActive3(false);
    //             setFinish2(false)
    //             break;
    //         case 3:
    //             setActive1(false);
    //             setActive2(false);
    //             setActive3(true);
    //             setFinish2(true)
    //             break;
    //         default:
    //             setActive1(false);
    //             setActive2(false);
    //             setActive3(false);
    //             setFinish2(false)
    //             break;
    //     }
    // }, [step]);

return (
    <>
        {/* <header>
            <nav className="navbar navbar-expand navbar-light bg-white_ w-100 p-0">
                <div className="container header-container">
                    <Link className="navbar-brand my-2" to={HelperFunction.WEBSITE_URL}>
                        <img src={Images.logo} alt="siddhartha" className="h-logo" />
                    </Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div id="navigation">
                        <ul className="navbar-nav primary-menu ms-auto mb-2 mb-lg-0">
                            <li className="nav-item" title="Home">
                                <a className="nav-link" aria-current="page" href="/">Home</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
            <div className="h-btm">
                <div className="container bread-content">
                    <Link to={HelperFunction.WEBSITE_URL} className='bread-link'>Home</Link>
                    <FaAngleRight className='mx-2 mt-1'/>
                    <Link to={HelperFunction.BASE_URL} className='bread-link'>Book a Ticket</Link>
                    <FaAngleRight className='mx-2 mt-1'/>
                    <span className='bread-text'>{props.breadcrumb}</span>
                </div>
            </div>
        </header> */}
            <div class="d-flex justify-content-lg-center align-items-center container p-0">
                <header class="my-header second-header w-100">
                    <nav class="navbar navbar-expand-lg navbar-light bg-white_ w-100 p-0">
                        {/* <div class="header-top">
                            <div class="d-flex align-items-center">
                                <div class="header-text cursor-pointer d-none d-lg-flex" title="Contact">
                                    <a aria-current="page"
                                        title='Contact'
                                        href="https://www.siddharthacablecar.com.np/contact-us">Contact</a>
                                </div>
                                <div class="mx-1 header-text d-none d-lg-flex">|</div>
                                <div class="header-text d-none d-lg-flex">Emergency Call</div>
                                <div class="header-text d-none d-lg-flex">
                                    <a href="tel:071-534663">071-534663</a>
                                </div>
                            </div>
                        </div> */}
                        <div class="d-flex flex-md-row flex-column justify-content-md-between w-100 align-items-center">
                            {/* <a class="navbar-brand" href="{{ url('/') }}">
                                <img class="header-logo" src="{{ asset('assets/frontend/img/Logo.png') }}" alt="siddhartha-cable-car">
                            </a> */}
                            <div className='d-flex align-items-center justify-content-md-start justify-content-center logo-width'>
                                <Link className="navbar-brand my-2" title="Siddhartha Cable Car" to='https://www.siddharthacablecar.com.np/'>
                                    <img src={Images.logo} alt="Siddhartha Cable Car" className="h-logo" />
                                </Link>
                            </div>
                            {/* <div className='d-md-flex d-none'> */}
                            <div className='d-flex my-2 my-md-0'>
                                <div className="d-flex flex-column me-5 pe-3">
                                    <b>Cable Car </b>
                                    <span className="clock-text position-relative">
                                        <div className='position-absolute clock'><FaRegClock /></div> 10:15 AM to 5:30 PM
                                    </span>
                                </div>
                                <div className="d-flex flex-column">
                                    <b>Lunch break </b>
                                    <span className="clock-text position-relative">
                                        <div className='position-absolute clock'><FaRegClock /></div> 1 PM to 2 PM
                                    </span>
                                </div>
                            </div>
                            {/* <h1 className='main-title display-6 text-uppercase pt-4'>Book a Ticket</h1> */}
                            {/* <div id="formindicator" className='w-50'>
                                <div class="form-header d-flex my-2">
                                    <span class={`stepIndicator ${active1 ? 'active' : 'finish'}`}>Choose Ticket</span>
                                    <span class={`stepIndicator ${active2 ? 'active' : finish2 ? 'finish' : ''}`}>Customer Details</span>
                                    <span class={`stepIndicator ${active3 ? 'active' : ''}`}>Confirmation</span>
                                </div>
                            </div> */}
                            {/* <div class="position-relative d-flex w-100 justify-content-end me-md-0 me-3  align-items-center align-items-lg-end ">
                                <button class="navbar-toggler collapsed p-0" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                                    aria-label="Toggle navigation">
                                    <FaBars />
                                </button>
                                <div class= "collapse navbar-collapse justify-content-lg-end w-100 h-100 align-items-end"
                                    id="navbarSupportedContent">
                                    <button class="navbar-toggler navbar-toggler-close collapsed p-0" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                                    aria-label="Toggle navigation">
                                        <FaTimes className='text-white' />
                                    </button>
                                    <div class="w-100 h-100 mt-1 d-flex justify-content-center align-items-center" id="navigation">
                                        <ul class="navbar-nav w-100 h-100 justify-content-start justify-content-lg-end align-items-end mb-5">
                                            <Link to="/" class="nav-item" title="Home">
                                                <a class="header-link" title="Home">Home</a>
                                            </Link>
                                            <li class="nav-item-dropdown dropdown" title="About">
                                                <a class="header-link dropdown-toggle cursor-pointer" id="mediaDropdown" data-bs-toggle="dropdown" > About <span class="dropdown-icon">
                                                    <FaCaretDown />
                                                    </span></a>
                                                <ul class="dropdown-menu">
                                                    <li class="dropdown-items" aria-labelledby="mediaDropdown">
                                                        <a title="About Us" href="https://www.siddharthacablecar.com.np/about-us">About Us</a>
                                                        <a title="Introduction" href="https://www.siddharthacablecar.com.np/introduction">Introduction</a>
                                                        <a title="Chairperson's Message" href="https://www.siddharthacablecar.com.np/chairperson-message">Chairperson's Message</a>
                                                        <a title="Management Team" href="https://www.siddharthacablecar.com.np/management-team">Management Team</a>
                                                        <a title="Partners" href="https://www.siddharthacablecar.com.np/partners">Partners</a>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li class="nav-item-dropdown dropdown" title="Attraction">
                                                <a class="header-link dropdown-toggle cursor-pointer" id="mediaDropdown" data-bs-toggle="dropdown" >Attractions <span class="dropdown-icon">
                                                    <FaCaretDown />
                                                    </span></a>
                                                <ul class="dropdown-menu">
                                                    <li class="dropdown-items" aria-labelledby="mediaDropdown">
                                                        <a title="Artistic Waiting Hall"
                                                            href="https://www.siddharthacablecar.com.np/artistic-waiting-hall">
                                                            Artistic Waiting Hall
                                                        </a>
                                                    </li>
                                                    <li class="dropdown-items" aria-labelledby="mediaDropdown">
                                                        <a title="Cable Car"
                                                            href="https://www.siddharthacablecar.com.np/cable-car">
                                                            Cable Car
                                                        </a>
                                                    </li>
                                                    <li class="dropdown-items" aria-labelledby="mediaDropdown">
                                                        <a title="Dhungedhara"
                                                            href="https://www.siddharthacablecar.com.np/dhungedhara">
                                                            Dhungedhara
                                                        </a>
                                                    </li>
                                                    <li class="dropdown-items" aria-labelledby="mediaDropdown">
                                                        <a title="Serene Garden"
                                                            href="https://www.siddharthacablecar.com.np/serene-garden">
                                                            Serene Garden
                                                        </a>
                                                    </li>
                                                    <li class="dropdown-items" aria-labelledby="mediaDropdown">
                                                        <a title="Temple"
                                                            href="https://www.siddharthacablecar.com.np/temple">
                                                            Temple
                                                        </a>
                                                    </li>
                                                    <li class="dropdown-items" aria-labelledby="mediaDropdown">
                                                        <a title="Water Fountain with Revolving Globe"
                                                            href="https://www.siddharthacablecar.com.np/water-fountain-with-revolving-globe">
                                                            Water Fountain with Revolving Globe
                                                        </a>
                                                    </li>
                                                    <li class="dropdown-items" aria-labelledby="mediaDropdown">
                                                        <a title="Spacious Parking"
                                                            href="https://www.siddharthacablecar.com.np/spacious-parking">
                                                            Spacious Parking
                                                        </a>
                                                    </li>
                                                    <li class="dropdown-items" aria-labelledby="mediaDropdown">
                                                        <a title="Restaurant"
                                                            href="https://www.siddharthacablecar.com.np/restaurant">
                                                            Restaurant
                                                        </a>
                                                    </li>
                                                    <li class="dropdown-items" aria-labelledby="mediaDropdown">
                                                        <a title="Architectural Marvels"
                                                            href="https://www.siddharthacablecar.com.np/architectural-marvels">                                       
                                                            Architectural Marvels
                                                        </a>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li class="nav-item" title="Nuwakot Tourism">
                                                <a class="header-link" title="Nuwakot Tourism" href="https://www.siddharthacablecar.com.np/nuwakot-tourism">Nuwakot Tourism</a>
                                            </li>
                                            <li class="nav-item-dropdown dropdown" title="Media and Notices">
                                                <a class="header-link dropdown-toggle cursor-pointer" id="mediaDropdown" data-bs-toggle="dropdown" >
                                                    Media and Notices <span class="dropdown-icon">
                                                        <FaCaretDown />
                                                        </span></a>
                                                <ul class="dropdown-menu">
                                                    <li class="dropdown-items" aria-labelledby="mediaDropdown">
                                                        <a title="Notices" href="https://www.siddharthacablecar.com.np/notices">Notices</a>
                                                        <a title="Photo Gallery" href="https://www.siddharthacablecar.com.np/photo-gallery">Photo Gallery</a>
                                                        <a title="Media Coverage" href="https://www.siddharthacablecar.com.np/media-coverage">Media Coverage</a>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li class="nav-item d-lg-none d-flex" title="Contact">
                                                <a class="header-link" aria-current="page"
                                                    href="https://www.siddharthacablecar.com.np/contact-us">Contact</a>
                                            </li>
                                            <div class="nav-btn-container d-lg-block d-flex justify-content-center">
                                                <a title="Book a ticket" class="nav-btn btn-flat btn-primary"
                                                    href="/.#newsletter-section">
                                                    Book a ticket
                                                </a>
                                            </div>
                                            <div class="d-flex mt-4 header-top-ham">
                                                <div class="header-text-ham d-flex d-lg-none me-2">Emergency Call</div>
                                                <div class="header-text-ham d-flex d-lg-none">
                                                    <a href="tel:071-534663">071-534663</a>
                                                </div>
                                            </div>
                                        </ul>
                                    </div>

                                </div>
                            </div> */}
                        </div>
                    </nav>
                </header>
            </div>
    </>
)
}

export default Header
